export const checkboxValidator = (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('请勾选协议')));
